import React, {useEffect} from 'react';
import {FormattedMessage} from 'react-intl';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {ForgotPasswordContextProvider} from '../../components/ForgotPasswordContext';
import PageHeader from '../../../../common/components/ui/PageHeader';
import SectionPanel from '../../../../common/components/ui/SectionPanel';
import FieldEmail from '../../components/FieldEmail';
import ButtonReset from '../../components/ButtonReset';
import ButtonLink from '../../components/ButtonLink';
import FooterLogo from '../../../../common/components/ui/FooterLogo';
import {pathnames as P} from '../../../../common/enums';
import styles from './ForgotPassword.module.scss';

const ForgotPassword = () => {
  const {setPageTitle} = useGlobalContext();

  useEffect(() => {
    setPageTitle((
      <PageHeader
        id={'forgot-password-page-header'}
        defaultMessage={'Forgot password'}
        showLogo={true}
      />
    ));
  }, []);

  return (
    <ForgotPasswordContextProvider>
      <SectionPanel className={styles.forgotPasswordContainer}>
        <div className={styles.message}>
          <FormattedMessage
            id={'forgot-password-message'}
            defaultMessage={'Please write your email address and we will send you a link to reset your password'}
          />
        </div>
        <FieldEmail/>
        <ButtonReset/>
        <ButtonLink
          link={P.LOGIN}
          label={
            <FormattedMessage
              id={'button-back-to-login'}
              defaultMessage={'Back to Login'}
            />
          }
        />
      </SectionPanel>
      <FooterLogo/>
    </ForgotPasswordContextProvider>
  );
};

export default ForgotPassword;
